import { VIRTUAL } from "../object.types";

let translate = undefined;

const setTranslateObjectType = obj => (translate = obj);

const getTypeName = type => {
  return translate && translate[type] ? translate[type] : type;
};

const getTableData = (list, showUnused) => {
  let items = showUnused ? list : list.filter(p => p.used.length > 0);
  return items.map(item => {
    return {
      id: item.id,
      code: item.code,
      name: item.name,
      type: item.type,
      typeName: getTypeName(item.type),
      used: item.used
    };
  });
};

const prepareToSave = obj => {
  return {
    data: {
      code: obj.code,
      name: obj.name,
      type: VIRTUAL,
      used: obj.used || []
    }
  };
};

const prepareToChange = (items, id) => {
  let item = items.find(item => item.id === id);
  if (item) {
    return {
      id: item.id,
      data: {
        used: item.used
      }
    };
  }
  return undefined;
};

export { getTableData, setTranslateObjectType, prepareToSave, prepareToChange };
